/* eslint-disable @typescript-eslint/default-param-last */
import { GET_PLATFORM_META } from "@/constants/ActionTypes";
import initialState from "@/store/initialState";
import { IPlatformMetaAction } from "@/types/platformMeta.types";

const platformMetaReducer = (
  state = initialState.platformMeta,
  action: IPlatformMetaAction,
) => {
  switch (action.type) {
    case `${GET_PLATFORM_META}_SUCCESS`:
      return { ...state, ...action.payload.platformMeta };
    default:
      return state;
  }
};

export default platformMetaReducer;
